import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VinFormPage } from './vin-form.page';

const routes: Routes = [
  {
    path: '',
    component: VinFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VinFormPageRoutingModule {}
